import React from "react";
import { WrapperPage } from "../../components/shared/WrapperPage";
import AmazonIdeas from "../../components/amazon-idea";
import { useAppContext } from "../../context";
import { isPME_TEAM } from "../../helper";

export default function AmazonIdeaPage() {
    const { currentUser } = useAppContext();
    const isPME = isPME_TEAM(currentUser);
    return (
        <WrapperPage>
            {isPME ? (
                <AmazonIdeas />
            ) : (
                <p>You don't have privilege to access this route</p>
            )}
        </WrapperPage>
    );
}
